import { newAPI, changeBaseNewAPI, setNewAPI, setBaseNewAPI } from './newAPI';

const setToken = token => {
  newAPI.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export { newAPI, changeBaseNewAPI, setNewAPI, setBaseNewAPI }
export { setToken }